<script setup>
defineProps({
  show: { type: Boolean, default: false },
  errors: { type: Array, default: () => [] },
  warnings: { type: Array, default: () => [] },
});

const emit = defineEmits(['close']);
</script>

<template>
  <div
    v-if="show"
    class="absolute bottom-4 ltr:left-56 rtl:right-56 z-30 w-[420px] max-w-full rounded-xl border border-n-weak bg-n-solid-1 shadow-xl"
  >
    <div class="flex items-center justify-between px-4 py-2 border-b border-n-weak">
      <span class="text-sm font-semibold text-n-slate-12">
        {{ $t('FLOWS.BUILDER.VALIDATION.TITLE') }}
      </span>
      <button type="button" class="p-1 rounded text-n-slate-11 hover:bg-n-alpha-2" @click="emit('close')">
        <span class="i-lucide-x block" />
      </button>
    </div>
    <div class="max-h-64 overflow-y-auto p-3 flex flex-col gap-1.5">
      <p v-if="!errors.length && !warnings.length" class="text-sm text-n-teal-11 flex items-center gap-1">
        <span class="i-lucide-check-circle" /> {{ $t('FLOWS.BUILDER.VALIDATION.ALL_GOOD') }}
      </p>
      <p v-for="(error, index) in errors" :key="`e-${index}`" class="text-xs text-n-ruby-11 flex items-start gap-1">
        <span class="i-lucide-circle-x mt-0.5 shrink-0" /> {{ error }}
      </p>
      <p v-for="(warning, index) in warnings" :key="`w-${index}`" class="text-xs text-n-amber-11 flex items-start gap-1">
        <span class="i-lucide-triangle-alert mt-0.5 shrink-0" /> {{ warning }}
      </p>
    </div>
  </div>
</template>
